module.exports = __webpack_public_path__ + "files/cab0789bc7cdb133b39e2959ab11b1a5.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/activity-2.png
// module id = 1468
// module chunks = 60